import { DisplayName } from '../components/select/base-select-with-id.component';
import { BaseModel } from './base';

export class Filter implements DisplayName {
    id: string;
    label?: string;

    get displayName(): string {
        return this.label ? this.label : this.id;
    }

    constructor(json?: any) {
        if (json) {
            this.id = json.id;
        }
    }
}

export class FilterGroup extends BaseModel {
    public id: string;
    public filters: Filter[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            filters: json && json.filters ? json.filters.map((item: any) => new Filter(item)) : []
        });
    }
}
